import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  id?: number;
  title: string;
  copyrightText: string;
  field_copyright_text_ms: string;
  field_copyright_text_zh: string;
  registrationText: string;
  field_registration_number_txt_ms: string;
  field_registration_number_txt_zh: string;
  mobileAppText: string;
  field_mobile_app_text_ms: string;
  field_mobile_app_text_zh: string;
  termsOfUseText: string;
  field_term_of_use_text_ms: string;
  field_term_of_use_text_zh: string;
  termsOfUseLink: string;
  privacyPolicyText: string;
  field_privacy_policy_text_ms: string;
  field_privacy_policy_text_zh: string;
  privacyPolicyLink: string;
  playStoreImage: string;
  playStoreLink: string;
  appStoreImage: string;
  appStoreLink: string;
  published?: boolean;
}

// edit api call
const fetchFooterWebsiteDetails = async (id: string): Promise<DocumentDetailsResponse> => {
  const response: any = await passengerCMSApi.get(`/api/web-app-footer/all`);
  console.log(response.data, "test");
  return response?.data[0];
};

const useFooterWebsiteDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError>(
    {
      queryKey: ["footerWebsiteDocumentDetails", id],
      enabled: !!id,
      queryFn: () => fetchFooterWebsiteDetails(id),
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useFooterWebsiteDocumentDetails };
